import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const gcSkewTool: Tool = {
  id: "gc-skew",
  name: () => m.gcskew_tool_name(),
  description: () => m.gcskew_tool_description(),
  icon: "📈",
  basePath: "/gc-skew",
  status: "stable",
  tags: ["bioinformatics", "dna", "sequence", "science", "gc-skew", "genomics"],
};
